import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { TestIssueService } from '@/api/testIssue';
import { Section } from '@/components/Section';
import { Loading } from '@/components/Loading';
import { Paginator } from 'primereact/paginator';
import { CardLogs } from './CardLogs';
import { ITestIssueLogSchema } from '@/api/testIssueLog';

import 'primereact/resources/themes/lara-light-cyan/theme.css';
import 'primereact/resources/primereact.min.css';

type StatusHistoryProps = {
  id: string;
};

export const StatusHistory: React.FC<StatusHistoryProps> = ({ id }) => {
  const { testIssueId } = useParams();
  const { data, isFetching } = TestIssueService.useGetStatusLogs(
    testIssueId! ?? id,
  );

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(6);

  if (isFetching) {
    return (
      <Section>
        <Loading />
      </Section>
    );
  }

  const logs: ITestIssueLogSchema[] = data || [];
  const totalRecords = logs.length;

  const onPageChange = (e: { first: number; rows: number }) => {
    setFirst(e.first);
    setRows(e.rows);
  };

  const paginatedLogs = logs.slice(first, first + rows);
  const startIndex = first + 1;

  return (
    <Section>
      <div>
        {logs.length === 0 ? (
          <div className="text-center">No status changes</div>
        ) : (
          <>
            <div className="grid grid-cols-2 gap-4">
              {paginatedLogs.map((log, index) => (
                <CardLogs
                  key={log.uuid}
                  number={startIndex + index}
                  status_before={log.status_before}
                  status_after={log.status_after}
                  updatedBy={log.updated_by?.full_name}
                  updatedAt={new Date(log.updated_at).toString()}
                />
              ))}
            </div>
            <div className="mt-4">
              <Paginator
                first={first}
                rows={rows}
                totalRecords={totalRecords}
                onPageChange={onPageChange}
              />
            </div>
          </>
        )}
      </div>
    </Section>
  );
};
